import { Suspense } from 'react'
import { Links, Meta, Outlet, Scripts, ScrollRestoration } from 'react-router'
import { ErrorHandler, FullPageSpinner } from '@trinity/components'

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang='en'>
      <head>
        <meta charSet='UTF-8' />
        <meta name='viewport' content='width=device-width, initial-scale=1, maximum-scale=1, shrink-to-fit=no' />
        <meta name='theme-color' content='#000000' />
        {/* Added maximum-scale on viewport meta to remove auto-zooming on iPhone -- see details:
      https://stackoverflow.com/questions/2989263/disable-auto-zoom-in-input-text-tag-safari-on-iphone/46254706#46254706 */}
        <link
          rel='stylesheet'
          href='https://fonts.googleapis.com/css?family=Montserrat:500,500i,600,700&display=swap'
        />
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  )
}

export function HydrateFallback() {
  return null
}

export default function Root() {
  return (
    <Suspense fallback={<FullPageSpinner />}>
      <Outlet />
    </Suspense>
  )
}

export function ErrorBoundary() {
  return <ErrorHandler />
}
